<template>
    <img src="@images/portal/filters-empty.svg" alt="" />
</template>
<script>
export default {
    name: "FiltersEmptyInboxIcon"
}
</script>
